import { forwardRef, HTMLProps } from 'react';
import styled from 'styled-components';
import { FloatingOverlay, useMergeRefs } from '@floating-ui/react';
import { floatingComponentStyles } from '../../styles/shareableStyles';
import { useKubitPopoverContext } from './KubitPopoverContext';
import { FloatingLayer } from '../FloatingManager';

const StyledPopover = styled.div`
  ${floatingComponentStyles};
`;
const StyledFloatingOverlay = styled(FloatingOverlay)`
  background-color: rgba(0, 0, 0, 40%);
`;

const KubitPopoverContent = forwardRef<
  HTMLDivElement,
  HTMLProps<HTMLDivElement>
>(({ style, ...props }, propRef) => {
  const { context: floatingContext, getFloatingProps } =
    useKubitPopoverContext();
  const ref = useMergeRefs([floatingContext.refs.setFloating, propRef]);

  if (!floatingContext.open) {
    return null;
  }

  return (
    <FloatingLayer>
      <StyledFloatingOverlay lockScroll={true}>
        <StyledPopover
          ref={ref}
          style={{ ...style, ...floatingContext.floatingStyles }}
          {...getFloatingProps(props)}
        >
          {props.children}
        </StyledPopover>
      </StyledFloatingOverlay>
    </FloatingLayer>
  );
});

export default KubitPopoverContent;
